import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import TerminalLog from "@/components/TerminalLog";
import { Toaster } from "@/components/ui/sonner";

const Layout = () => {
  return (
    <div className="min-h-screen flex bg-[var(--bg)]">
      <Sidebar />
      <main className="flex-1 min-w-0 pb-12">
        <Outlet />
      </main>
      <TerminalLog />
      <Toaster position="bottom-right" richColors />
    </div>
  );
};

export default Layout;
